import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataService} from '../../../core/services';
import {IRegion} from '../../../core/models';
import {MatSliderChange} from '@angular/material';

export interface IGeoNearSearch {
  region: IRegion;
  distance: number;
}

@Component({
  selector: 'app-near-regions-search',
  templateUrl: './near-regions-search.component.html',
  styleUrls: ['./near-regions-search.component.css']
})
export class NearRegionsSearchComponent implements OnInit {
  @Input() data: IGeoNearSearch;
  @Output() regions = new EventEmitter<number[]>();
  constructor(private dataService: DataService) { }

  ngOnInit() {
  }

  onSearch(event: MatSliderChange) {
    console.log(this.data);
    // this.data.distance = event.value;
    this.dataService.getNearByRegions(this.data).subscribe( res => {
      console.log(res);
      this.regions.emit(res.regions);
    });
  }
}
